export const indoPakList = [
  { id: 1, name: "15 Lines", value: "15-lines" },
  { id: 2, name: "16 Lines", value: "16-lines" },
];

